import { DoqFaceSvgProps } from '../types';

const SpiderChart = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1409_42012)">
      <g clipPath="url(#clip1_1409_42012)">
        {/* mask to hide the bottom outline of the circle */}
        <mask id="bottom-mask-spider-chart">
          <circle cx="160" cy="160" r="160" fill="white" />
          <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
        </mask>
        <circle
          cx="160"
          cy="160"
          r="160"
          fill="#8800FF"
          mask="url(#bottom-mask-spider-chart)"
        />

        <mask
          id="mask0_1409_42012"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
        </mask>
        <g mask="url(#mask0_1409_42012)">
          <rect x="80" y="120" width="160" height="200" fill="white" />
        </g>
        <path
          d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
          fill="#2974C4"
        />
        <path
          d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
          fill="#2974C4"
        />
        <path
          opacity="0.5"
          d="M88 240C88 235.582 91.5817 232 96 232H224C228.418 232 232 235.582 232 240V296C232 300.418 228.418 304 224 304H96C91.5817 304 88 300.418 88 296V240Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160.344 234.355C160.344 234.079 160.12 233.855 159.844 233.855C159.568 233.855 159.344 234.079 159.344 234.355V237.132L133.313 252.161L130.98 250.814C130.741 250.676 130.435 250.758 130.297 250.997C130.159 251.236 130.241 251.542 130.48 251.68L133.153 253.223V282.977L130.48 284.52C130.24 284.658 130.158 284.964 130.297 285.203C130.435 285.442 130.74 285.524 130.98 285.386L133.914 283.692L159.344 298.374V301.645C159.344 301.921 159.568 302.145 159.844 302.145C160.12 302.145 160.344 301.921 160.344 301.645V298.554L186.005 283.739L188.858 285.386C189.097 285.524 189.403 285.442 189.541 285.203C189.679 284.964 189.597 284.658 189.358 284.52L186.847 283.07V253.129L189.357 251.68C189.596 251.542 189.678 251.236 189.54 250.997C189.402 250.758 189.096 250.676 188.857 250.814L186.606 252.114L160.344 236.951V234.355ZM159.344 239.441L135.313 253.315L143.705 258.161L159.344 249.132V239.441ZM160.344 248.951V239.261L184.606 253.268L176.214 258.114L160.344 248.951ZM159.344 250.286L144.705 258.738L149.767 261.661L159.344 256.132V250.286ZM160.344 255.951V250.106L175.214 258.691L170.152 261.614L160.344 255.951ZM159.344 257.286L150.767 262.238L159.344 267.19V257.286ZM160.344 267.277V257.106L169.152 262.191L160.344 267.277ZM159.344 269.009L150.502 274.114L159.344 279.219V269.009ZM160.344 279.4V268.922L169.417 274.161L160.344 279.4ZM159.344 280.374L149.502 274.692L145.306 277.114L159.344 285.219V280.374ZM160.344 285.4V280.554L170.417 274.739L174.613 277.161L160.344 285.4ZM159.344 286.374L144.306 277.692L135.914 282.537L159.344 296.064V286.374ZM160.344 296.245V286.554L175.613 277.739L184.005 282.584L160.344 296.245ZM176.454 259.13L184.847 254.284V281.915L176.454 277.07V259.13ZM175.454 259.707L170.825 262.38V273.82L175.454 276.492V259.707ZM169.825 262.957L160.919 268.1L169.825 273.242V262.957ZM150.175 263.051L158.919 268.1L150.175 273.149V263.051ZM149.175 262.474V273.726L144.545 276.399V259.801L149.175 262.474ZM143.545 259.223V276.976L135.153 281.822V254.378L143.545 259.223Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160.851 200.005C159.816 200.082 159 200.946 159 202C159 203.105 159.895 204 161 204H175.5C177.433 204 179 205.567 179 207.5C179 207.67 178.988 207.837 178.964 208.001L179 208.001C179.001 209.105 179.896 210 181 210C182.105 210 183 209.105 183 208C183 207.942 182.997 207.884 182.993 207.826L182.984 208.001C182.994 207.835 183 207.668 183 207.5C183 203.358 179.642 200 175.5 200H161L160.851 200.005Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1409_42012">
        <rect width="320" height="320" fill="white" />
      </clipPath>
      <clipPath id="clip1_1409_42012">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { SpiderChart };
